import React, { useState } from 'react'
import NotificationContext from './NotificationContext';
import SimpleToaster from './SimpleToaster'

const NotificationState = (props) => {
    const [stateNotification, setStateNotification] = useState(false);
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
    const [notification, setNotification] = useState('');

    const hideNotification = () => {
        setTimeout(() => {
            setStateNotification(false);
            setSuccess(false);
            setFailed(false);
            setNotification('');
        }, 3000);
    }

    const showNotification = (typeNofificacion, message) =>{
        if(typeNofificacion === 'success'){
            setSuccess(true);
            setFailed(false);  
        } 
        if(typeNofificacion === 'failed') {
            setFailed(true);
            setSuccess(false);
        }
        setStateNotification(true);
        setNotification(message);
        hideNotification();
    }


  return (
    <NotificationContext.Provider value={{showNotification, success, failed, notification, stateNotification}}>
        {props.children}
        <SimpleToaster success={success} failed={failed} active={stateNotification} message={notification} />
    </NotificationContext.Provider>
  )
}

export default NotificationState
